import { Layout } from 'antd';
import { StyledPublicPage as DefaultStyledPublicPage } from './PublicPage.styled';
import PublicPageFooter from './PublicPageFooter/PublicPageFooter';
import Version from '../Version/Version';
import PublicTopbar from '@/v2/components/PublicTopbar/PublicTopbar';
import usePublicPage from './usePublicPage.hook';
const { Content } = Layout;

export default function PublicPage({
  title,
  children,
  noPadding,
  withFooter,
  noMaxWidth,
  StyledPublicPage = DefaultStyledPublicPage,
}) {
  usePublicPage();

  return (
    <StyledPublicPage
      noPadding={noPadding}
      withFooter={withFooter}
      noMaxWidth={noMaxWidth}
    >
      <div className="public-page-topbar">
        <PublicTopbar />
      </div>
      <Layout className="public-page-layout">
        <Content className="public-page-content">
          {title}
          {children}
        </Content>
      </Layout>
      {withFooter ? <PublicPageFooter /> : null}
      <Version />
    </StyledPublicPage>
  );
}
